module.exports = __webpack_public_path__ + "img/shared_group.46d90ebf.svg";